export const QUIZ_BRAND = {
  name: 'UNESCO - CREGU India',
  title: 'National Level Quiz Competition',
  subtitle: 'Youth Education Research Center in India',
} as const;

export const COMPETITION = {
  shortName: 'NKC 2026',
  title: 'National Knowledge Championship',
  year: 2026,
  timezone: 'Asia/Kolkata',
  defaultFinalistCapacity: 100,
  organizers: [QUIZ_BRAND.name, QUIZ_BRAND.subtitle],
  enabledClasses: [6, 7, 8, 9, 10, 11, 12],
} as const;

export const COMPETITION_SCHEDULE = {
  registrationClose: { label: 'Registration closes', date: 'Not yet announced', detail: 'Check this page for the registration closing date.' },
  level1Results: { label: 'First Level Results', date: '10 November 2026', isoDate: '2026-11-10' },
  level2Exam: { label: 'Grand Finale · Second Level', title: 'Grand Finale', stage: 'Second Level', date: '14 November 2026', isoDate: '2026-11-14' },
  format: 'Two levels only. No third level.',
} as const;

